module.exports = __webpack_public_path__ + "static/media/linha-miolo.51385f50.svg";